// resolves typography from path inside theme object
export const resolveTypographyFromTheme = (theme, pathToKey, fallback) => {
  const key = pathToKey
    .split('.')
    .reduce(
      (obj, prop) => (obj && obj[`${prop}`] !== undefined ? obj[`${prop}`] : undefined),
      theme
    );

  return theme.typography?.[`${key}`] || theme.typography?.[`${fallback}`] || {};
};

// resolves typography to be used for the theme from map object
export const getTypographyFromMap = (theme, typographyMap, fallback) => {
  const resolvedFallback = fallback || typographyMap?.DEFAULT;
  const fontKey = typographyMap?.[theme?.name] || resolvedFallback;

  return theme?.typography?.[`${fontKey}`] || {};
};
